import { render, staticRenderFns } from "./IconTicket.vue?vue&type=template&id=9887486c&"
import script from "./IconTicket.vue?vue&type=script&lang=js&"
export * from "./IconTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports